import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { LanguageService } from '../../services/language.service';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-landing',
    imports: [CommonModule, RouterModule, TranslateModule],
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss']
})
export class LandingComponent {
  readonly appVersion = environment.appVersion;
  supportedLanguages = this.languageService.getSupportedLanguages();
  currentLanguage$ = this.languageService.currentLanguage$;
  isAuthenticated$ = this.authService.isAuthenticated$;

  features = [
    { icon: '👥', keyPrefix: 'pages.landing.features.players' },
    { icon: '✅', keyPrefix: 'pages.landing.features.attendance' },
    { icon: '💰', keyPrefix: 'pages.landing.features.payments' },
    { icon: '🏆', keyPrefix: 'pages.landing.features.teams' },
    { icon: '💬', keyPrefix: 'pages.landing.features.communication' },
    { icon: '📊', keyPrefix: 'pages.landing.features.analytics' }
  ];

  pricingPlans = [
    {
      keyPrefix: 'pages.landing.pricing.starter',
      isFeatured: false
    },
    {
      keyPrefix: 'pages.landing.pricing.pro',
      isFeatured: true
    },
    {
      keyPrefix: 'pages.landing.pricing.enterprise',
      isFeatured: false
    }
  ];

  constructor(
    public languageService: LanguageService,
    private authService: AuthService
  ) {}

  setLanguage(lang: 'pl' | 'en' | 'de'): void {
    this.languageService.setLanguage(lang);
  }

  getLanguageLabel(lang: 'pl' | 'en' | 'de'): string {
    return this.languageService.getLanguageLabel(lang);
  }

  logout(): void {
    this.authService.logout();
  }
}
